import React from 'react'
import Grid from '@mui/material/Grid'
import withCapabilities from '../../hoc/withCapabilities'
import { FooterContent, FooterWrapper, RightGrid } from './Footer.styled'
import FooterLeftContent from './FooterLeftContent/FooterLeftContent'
import FooterRightContent from './FooterRightContent/FooterRightContent'

const Footer: React.FC = () => {
  return (
    <FooterWrapper>
      <FooterContent spacing={10}>
        <Grid size={{ mobile: 12, tablet: 6, desktop: 6 }}>
          <FooterLeftContent />
        </Grid>
        <RightGrid size={{ mobile: 12, tablet: 6, desktop: 6 }}>
          <FooterRightContent />
        </RightGrid>
      </FooterContent>
    </FooterWrapper>
  )
}

export default withCapabilities(Footer)
